import * as leadTypes from './mutations_types'
import { get } from 'services/leads'

export const loadLead = (context, id) => {
    return get(id)
        .then(response => context.commit(leadTypes.SET, response.data))
}

export const setLead = (context, lead) => context.commit(leadTypes.SET, lead)

export const clearLead = (context) => context.commit(leadTypes.CLEAR)

export const saveLeadInfo = (context, info) => context.commit(leadTypes.SET_INFO, info)

export const saveLeadDeal = (context, item) => context.commit(leadTypes.SAVE_DEAL, item)

export const destroyLeadDeal = (context, id) => context.commit(leadTypes.DESTROY_DEAL, id)



// WEBPACK FOOTER //
// ./src/modules/leads/components/show/store/actions.js